// extracted by mini-css-extract-plugin
module.exports = {"listContent":"deliveryinContainerScreen_listContent__134X6","container":"deliveryinContainerScreen_container__3VdPR","row":"deliveryinContainerScreen_row__2wlIe"};